import React, { ReactElement, Ref, SyntheticEvent } from 'react';
import { Input, MaskedInput } from 'rsuite';
import { phoneMask } from '../../../common/validation';
import { FORM_INPUT_TYPES } from '../../../common/enums';
import { BaseTextInputWithErrorStatus } from './types';

interface TextInputWithErrorStatusProps extends BaseTextInputWithErrorStatus {
  placeholder?: string;
  ref?: Ref<HTMLDivElement>;
}

const removePhoneFormatting = (val: string): string => val?.replace(/\D+/g, '');

export const CustomTextInput = React.memo(
  ({
    disabled,
    inputFieldType,
    inputMode,
    name,
    onChange,
    placeholder,
    preventHtmlValidation,
    trimEndOnChange,
    trimStartOnChange,
    type,
    value,
    style,
  }: TextInputWithErrorStatusProps): ReactElement => {
    const changedInternal = (v: string, e: SyntheticEvent): void => {
      let result: string | number | undefined = v;
      if (trimStartOnChange) {
        result = result.trimStart();
      }
      if (trimEndOnChange) {
        result = result.trimEnd();
      }

      // remove any masks prior to saving to form values
      if (type === FORM_INPUT_TYPES.PHONE) {
        result = removePhoneFormatting(v);
      } else if (type === FORM_INPUT_TYPES.NUMBER) {
        if (result === '') {
          result = undefined;
        } else {
          result = Number(result);
        }
      }
      if (onChange) onChange(result, e);
    };

    return (
      <>
        {type === FORM_INPUT_TYPES.PHONE ? (
          <MaskedInput
            aria-label={`${name}-label`}
            placeholder={placeholder}
            onChange={changedInternal}
            value={value}
            style={{ backgroundColor: 'white' }}
            mask={phoneMask}
            disabled={disabled}
          />
        ) : (
          <Input
            aria-label={`${name}-label`}
            name={name}
            placeholder={placeholder}
            onChange={changedInternal}
            style={{ backgroundColor: 'white', ...style }}
            type={inputFieldType}
            {...(inputFieldType === 'textarea'
              ? { as: 'textarea', rows: 5 }
              : {})}
            {...(inputMode ? { inputMode } : {})}
            {...(preventHtmlValidation ? { noValidate: true } : {})}
            value={value}
            disabled={disabled}
            step="any"
          />
        )}
      </>
    );
  }
);
